export default __webpack_public_path__ + "static/media/burger.49a4e994.svg";